module.exports = __webpack_public_path__ + "f711fa727ea65aeb50e55472db070e0f.svg";